import React from "react";
import { useTheme } from "../context/ThemeProvider";
import { useContent } from "../context/ContentProvider";
import { useRealtimeHotelInfo } from "../hooks/useRealtimeHotelInfo";
import { useBooking } from "../context/BookingContext";
import { getFullImageUrl } from "../utils/imageUtils";

const Footer: React.FC = () => {
  const { theme } = useTheme();
  const { content } = useContent();
  const { selectedHotel } = useBooking();
  const { hotelInfo } = useRealtimeHotelInfo(selectedHotel?.name || '');
  console.log('🏨 Footer Debug:', {
    themeHotelAddress: theme.hotelAddress,
    hotelInfoAddress: hotelInfo?.address,
    selectedHotel: selectedHotel?.name,
    theme
  });
  // Debug logs to check logo URLs
  console.log('🔍 Footer Debug:', {
    footerLogoUrl: theme.footerLogoUrl,
    logoUrl: theme.logoUrl,
    hasFooterLogo: !!theme.footerLogoUrl,
    hasLogo: !!theme.logoUrl
  });

  return (
    <footer
      className="bg-[#67273f] text-white py-12 px-4 z-10"
      style={{ backgroundColor: "var(--hotel-secondary-color)" }}
    >
      <div className="max-w-7xl mx-auto text-center">
        {/* Logo */}
        <div className="mb-4">
          {theme.footerLogoUrl ? (
            <img
              src={getFullImageUrl(theme.footerLogoUrl)}
              alt="Hotel Footer Logo"
              className="h-32 w-auto mx-auto"
              onError={(e) => {
                console.warn(
                  "Failed to load custom footer logo, falling back to default"
                );
                (e.target as HTMLImageElement).src =
                  "/logo-footer-white.png";
              }}
            />
          ) : theme.logoUrl ? (
            <img
              src={getFullImageUrl(theme.logoUrl)}
              alt="Hotel Logo"
              className="h-32 w-auto mx-auto"
              onError={(e) => {
                console.warn(
                  "Failed to load custom logo, falling back to default"
                );
                (e.target as HTMLImageElement).src =
                  "/logo-footer-white.png";
              }}
            />
          ) : (
            <img
              src="/logo-footer-white.png"
              alt="Hôtel Adriatica Logo"
              className="h-32 w-auto mx-auto"
            />
          )}
        </div>

        {/* Address */}
        {theme.hotelAddress && (
          <div className="mb-2">
            <p className="text-sm" style={{ fontFamily: "var(--hotel-body-font-family)" }}>
              {theme.hotelAddress}
            </p>
          </div>
        )}

        {/* Tel | Email */}
        <div className="mb-4">
          <p className="text-sm" style={{ fontFamily: "var(--hotel-body-font-family)" }}>
            Tel: <a
              href={`tel:${theme.contactPhone || ""}`}
              className="hover:underline transition-colors"
            >
              {theme.contactPhone || ""}
            </a> | Email: <a
              href={`mailto:${
                theme.contactEmail || ""
              }`}
              className="hover:underline transition-colors"
            >
              {theme.contactEmail || ""}
            </a>
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 pt-4">
          <p
            className="text-sm text-white/80"
            style={{ fontFamily: "var(--hotel-body-font-family)" }}
          >
            {content.footerText || ""}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
